
// region JS Imports

// region External Modules
import $ from "jquery"
import serialize from "form-serialize"

import I18n from "plugins/i18n-js"
// endregion External Modules

// Private Modules
import Google_event from "app/tracking/google/event"
import GA4_Event from "app/tracking/google/google_analytics_4/event"
import PageInstance from "app/page_instance/index"
import Modal from "app/modal/show-modal"
import Notifier from "app/notifier/index"

import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


interface Selector {
  scope:  string | JQuery | Element
  main:   string
}
interface InputSelector {
  scope?:  string | JQuery | Element
  main?:   string
}
const DEFAULT_SELECTOR = {
  scope:  ".cell--buildings--brochure--request--box",
  main:   ".cell--buildings--brochure--request--box_remote-submit-form",
}


const init = (selector?: InputSelector) => {
  const sele: Selector = Object.assign({}, DEFAULT_SELECTOR, selector)
  const $scope = $(sele.scope)
  const $el = $scope.find(sele.main)


  $el.on("submit", (e) => {
    e.preventDefault()

    q_ajax_3({
      url:      $el.attr("action"),
      method:   "POST",
      data:     serialize(($el[0] as HTMLFormElement), {hash: true}),
    })
    .then(() => {
      Notifier.showSuccess(I18n.t("concepts.buildings.brochure.request.box.notifier.success"))
      Google_event.track({
        category: PageInstance.currentPageNameForTracking(),
        action:   "Overseas Brochure Request",
        options:  {
          eventLabel: "Overseas Brochure Request - Submitted",
        },
      })

      GA4_Event.track({
        event_name: "op_brochure_request_submitted",
        options:    {
          page: PageInstance.currentPageNameForTracking(),
        },
      })
      Modal.hideTopModal()
    })
    .catch(() => {
      Notifier.showError(I18n.t("concepts.buildings.brochure.request.box.notifier.error"))
    })
    .done()
  })
}

export default {init}
